import { ComponentProps, FC, useContext } from 'react'
import { DropdownPrimitives } from '.'
import { DropdownContext } from '../DropdownContext'

export const Label: FC<ComponentProps<typeof DropdownPrimitives.Label>> = ({
  children,
  ...rest
}) => {
  const { isDarkMode } = useContext(DropdownContext)

  return (
    <DropdownPrimitives.Label dark={isDarkMode} {...rest}>
      {children}
    </DropdownPrimitives.Label>
  )
}
